import { render } from "./ImageCard.vue?vue&type=template&id=990539c6&scoped=true"
import script from "./ImageCard.vue?vue&type=script&lang=js"
export * from "./ImageCard.vue?vue&type=script&lang=js"

import "./ImageCard.vue?vue&type=style&index=0&id=990539c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-990539c6"]])

export default __exports__